import { Injectable, inject } from '@angular/core';
import { MessageService } from 'primeng/api';

/** Chave do `<p-toast key="app" />` no shell da aplicação. */
export const APP_TOAST_KEY = 'app';

export interface AppToastOptions {
  /** ms visível (padrão por severidade) */
  readonly life?: number;
}

@Injectable({
  providedIn: 'root',
})
export class ToastrService {
  private readonly messages = inject(MessageService);

  private baseOptions(severity: 'error' | 'success' | 'warn' | 'info', summary: string, detail: string, life: number) {
    this.messages.add({
      key: APP_TOAST_KEY,
      severity,
      summary,
      detail,
      life,
      closable: true,
    });
  }

  error(message: string, options?: AppToastOptions): void {
    this.baseOptions('error', 'Erro', message, options?.life ?? 5000);
  }

  attention(message: string, options?: AppToastOptions): void {
    this.baseOptions('warn', 'Atenção', message, options?.life ?? 4500);
  }

  success(message: string, options?: AppToastOptions): void {
    this.baseOptions('success', 'Sucesso', message, options?.life ?? 3200);
  }

  info(message: string, options?: AppToastOptions): void {
    this.baseOptions('info', 'Informação', message, options?.life ?? 3500);
  }
}
